export const protectionTypes = [
  { id: 0, value: 'All' },
  { id: 'COPYRIGHT', value: 'Copyright' },
  { id: 'GRAY_MARKET', value: 'Gray market' },
  { id: 'IMPERSONATION', value: 'Impersonation' },
  { id: 'PIRACY', value: 'Piracy' },
  { id: 'PRODUCT_BRAND_ABUSE', value: 'Brand abuse' },
  { id: 'PRODUCT_COUNTERFEIT', value: 'Counterfeit' },
  { id: 'PRODUCT_REPLICA', value: 'Replica' },
];

export const labelListSelector = [{ id: 'watch', value: 'Bookmark' }];

export const tableItemStatus = ['REJECTED_BY_PLATFORM', 'CLOSED', 'ENFORCED'];
export const tableItemDeindexed = 'DEINDEXED';
export const DATE_FILTERS = [
  'confirmationAtFrom',
  'confirmationAtTo',
  'createdAtFrom',
  'createdAtTo',
  'enforcementAtFrom',
  'enforcementAtTo',
  'closedAtFrom',
  'closedAtTo',
];
export const SUBTRACT_DAYS = 7;
export const MAX_NUMBER_RESULTS = 2500;
export const ALL_INCIDENTS_EXPORT_ENTITY_PERMISSION = {
  BRAND: 'export_brand',
  PIRACY: 'export_piracy',
};
